import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Order from './Order';

const OrderViewer: React.FC = (): any => (
  <div style={{ width: '100%', height: '100%' }}>
    <Routes>
      <Route
        path='/'
        element={<Order />}
      />
    </Routes>
  </div>
);

export default OrderViewer;
